import { Link, useLocation } from 'react-router-dom';

function Layout({ children }) {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white border-b">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/" className="text-lg font-bold text-gray-900 hover:text-gray-700">
            🍽️ Mood Food Recommender
          </Link>
        </div>
      </nav>
      
      <main className="max-w-4xl mx-auto px-4 py-8">
        {children}
      </main>
      
      <footer className="bg-white border-t mt-16">
        <div className="max-w-4xl mx-auto px-4 py-6 text-center text-gray-500 text-sm">
          <p>Mood Food Recommender © 2026</p>
          <p className="mt-1">Find food that fits how you feel.</p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
